import { faChevronRight, faCircleCheck, faClock } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import React from 'react'
import { chaseStatusData } from '../utils/data/chase-status-data'
import UseChaseProvider from '../utils/use-chase-provider'
import { IChaseItem } from '../types/chase-item-types'
import { chaseItemDataTypes } from '../utils/data/chase-item-data'

interface IChaseListItem {
    item: IChaseItem
    driverId?: number
}

const getStatus = (status: string) => {
    const statusData = chaseStatusData.find((stat) => stat.name === (status || "default"))
    return statusData
}

const disbaledStatus = ["Pending-Review", "Approved"]

const ChaseListItem: React.FC<IChaseListItem> = ({ item, driverId }) => {
    const { onSetChaseType, onSetDriverId } = UseChaseProvider()
    const providerDetails = chaseItemDataTypes.find((chaseItemDataType) => chaseItemDataType.id === item.type)!
    const isLocked = disbaledStatus?.includes(item?.status)

    return (
        <button type='button' disabled={isLocked} className={clsx(
            "group relative isolate overflow-hidden w-full text-left px-3 py-3.5 rounded-2xl transition-transform duration-200 ease-out-cubic",
            isLocked ? "cursor-default" : "cursor-pointer active:scale-[0.99]"
        )} onClick={() => {
            if (!disbaledStatus?.includes(item?.status)) {
                onSetChaseType(item?.type)
                onSetDriverId(driverId)
            }
        }}>
            <span className={clsx('absolute inset-0 -z-10 origin-left scale-x-[0.45] transition-transform duration-500 ease-out-cubic', getStatus(item?.status)?.wash, !isLocked && 'group-hover:scale-x-100')} aria-hidden />
            <div className='w-full flex items-center justify-between gap-3'>

                {/* -------------------- [ CHASE ITEM INFO ] -------------------- */}

                <div className='flex items-center justify-start gap-3.5 min-w-0'>
                    <span className={clsx('min-w-[44px] h-[44px] rounded-xl flex items-center justify-center text-[21px] transition-transform duration-300 ease-out-cubic', getStatus(item?.status)?.tile || 'bg-tile', !isLocked && 'group-hover:scale-105')} aria-hidden>{providerDetails.desc.split(" ").pop()}</span>
                    <div className='min-w-0'>
                        <h2 className={clsx('text-[15.5px] leading-[20px] font-bold', isLocked ? 'text-white/[0.85]' : 'text-white')}>{providerDetails?.label}</h2>
                        <p className={clsx('mt-1 inline-flex items-center gap-1.5 text-[13px] font-semibold', getStatus(item?.status)?.color)}>
                            <span className={clsx('w-1.5 h-1.5 rounded-full', getStatus(item?.status)?.bgColor)} />
                            {getStatus(item?.status)?.label}
                        </p>
                    </div>
                </div>

                {/* -------------------- [ CHASE ITEM INFO ] -------------------- */}


                {/* -------------------- [ CHASE ITEM CTA ] -------------------- */}

                <span className='w-5 shrink-0 flex items-center justify-center'>
                    {!isLocked && <FontAwesomeIcon icon={faChevronRight} className='text-[13px] text-app-link transition-transform duration-200 ease-out-cubic group-hover:translate-x-0.5' />}
                    {item?.status === "Approved" && <FontAwesomeIcon icon={faCircleCheck} className='text-[17px] text-success' />}
                    {item?.status === "Pending-Review" && <FontAwesomeIcon icon={faClock} className='text-[15px] text-white/[0.4]' />}
                </span>

                {/* -------------------- [ CHASE ITEM CTA ] -------------------- */}
            </div>
        </button>
    )
}

export default ChaseListItem
